export default __webpack_public_path__ + "assets/models/0837250d9e2b8cdd6261a81f8275a5ec.glb";